import { isEmpty } from 'lodash-es';

// Lang

export function isObject(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function cleanEmpty<T extends object>(obj: T): T {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- this function is known to have broken types
    return Object.fromEntries(
        Object.entries(obj)
            .map(([k, v]): [string, unknown] => [k, v && isObject(v) ? cleanEmpty(v) : v])
            .filter(
                ([, v]) =>
                    v !== null &&
                    v !== undefined &&
                    !(Array.isArray(v) && v.length === 0) &&
                    !(isObject(v) && isEmpty(v)),
            ),
    ) as T;
}
